import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { fetchReportPromotions, fetchReportRevenue, setReportsFilters } from '../../action';
import PointsSelect from '../utils/PointsSelect';
import DateSelect from '../utils/DateSelect';
import moment from 'moment';
import SortButton from '../utils/SortButton';
import { isEmpty } from 'lodash';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import { fetchFilials, fetchPayments, fetchSources } from '../../action/handbook';
import { defaultPlatforms, roleId } from '../../constants/app';
import { fetchUsersByRole } from '../../action/user';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorContainer from '../utils/ErrorContainer';
import MultiSelect from '../utils/MultiSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

function DetailRow ({item, thirdLvl, fourthLvl, color='#d5d4ff61', marginLeft = '0px' }) {
    const [ showDetail, setShowDetail ] = useState(false);

    if (item.name === 'Источник не определен') {
        if ((!item.count || item.count === 0) && (!item.receipt || item.receipt === 0) && (!item.totalSum || item.totalSum === 0)) return null;
    }

    const renderThrid = thirdLvl && thirdLvl.value !== 'none' && !isEmpty(item.detailData);
    const renderFourth = !renderThrid && fourthLvl && fourthLvl.value !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderThrid && !renderFourth) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderThrid || renderFourth) ? { cursor: 'pointer', backgroundColor: color } : { backgroundColor: color }}>
            <td className='kt-datatable__cell' style={{ width: '12px' }}>{(renderThrid || renderFourth) && <i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/>}</td>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={{ marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {(renderThrid || renderFourth) && showDetail && 
            Object.entries(item.detailData).map(([key, item]) => <DetailRow item={item} thirdLvl={renderThrid ? null : thirdLvl} fourthLvl={renderFourth ? null : fourthLvl} color={renderFourth ? '#aaa8ff61' : '#bbbaff61'} marginLeft={`${parseFloat(marginLeft) + 15}px`} />)
        }
        </>
    )
}

function ResultRow ({items}) {
    const result = Object.values(items).reduce((acc, item) => {
        acc.totalSum += item.totalSum || 0;
        acc.count += item.count || 0;
        return acc;
    }, { totalSum: 0, count: 0 });

    const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;

    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.totalSum) || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, secondLvl, thirdLvl, fourthLvl}) {
    const [ showDetail, setShowDetail ] = useState(false);
    const renderSecond = secondLvl && secondLvl.value !== 'none' && !isEmpty(item.detailData);
    const renderThrid = !renderSecond && thirdLvl && thirdLvl.value !== 'none' && !isEmpty(item.detailData);
    const renderFourth = !renderSecond && !renderThrid && fourthLvl && fourthLvl.value !== 'none' && !isEmpty(item.detailData);
    const handleClick = () => {
        if (!renderSecond && !renderThrid && !renderFourth) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderSecond || renderThrid || renderFourth) ? { cursor: 'pointer' } : {}}>
            {(renderSecond || renderThrid || renderFourth) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {(renderSecond || renderThrid || renderFourth) && showDetail && 
            Object.entries(item.detailData).map(([key, item]) => <DetailRow item={item} thirdLvl={renderThrid ? null : thirdLvl} fourthLvl={renderFourth ? null : fourthLvl} marginLeft='45px'/>)
        }
        </>
    )
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const firstLvlOptions = [
    { label: 'Нет', value: 'none', noRenderFirst: true },
    { label: 'Филиалы', value: 'points' },
    { label: 'Акции', value: 'promo' },
]

const dateOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'День', value: 'day', notRender: [ 'year' ]},
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ]},
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ]},
];

const typeOptions = [
    {label: 'Нет', value: 'none'},
    {label: 'Способ доставки', value: 'delivery'},
    {label: 'Оплата', value: 'payment'},
    {label: 'Источники', value: 'source'},
];

export default function RevenuePromotions() {
    const data = useSelector(state => state.reports.revenuePromotions);
    const payments = useSelector(state => state.handbook.payments);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const sources = useSelector(state => state.handbook.sources);
    const sourcesCount = useSelector(state => state.handbook.count.sources);
    const paymentsCount = useSelector(state => state.handbook.count.payments);

    const { result, filters, loading, promotions } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);
    const [ platforms, setPlatforms ] = useState(defaultPlatforms);

    const dispatch = useDispatch();

    const [ renderDetail, setRenderDetail ] = useState({
        firstLvl: { label: 'Акции', value: 'promo' },
        secondLvl: { label: 'Нет', value: 'none' },
        thirdLvl: { label: 'Нет', value: 'none' },
        fourthLvl: { label: 'Нет', value: 'none' },
    });

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
            if (isEmpty(promotions)) await dispatch(fetchReportPromotions('revenuePromotions'));
        };
        
        if (isEmpty(payments) || payments.length < paymentsCount) dispatch(fetchPayments(true));
        if (isEmpty(sources) || sources.length < sourcesCount) dispatch(fetchSources(true));
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isEmpty(sources)) setPlatforms(sources);
    }, [sources]);

    useEffect(() => {
        return () => {
            dispatch({type: 'RESET_REPORT', name: 'revenuePromotions'});
        }
    }, [dispatch]);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('revenuePromotions', updated));
        }
    }

    const setDetail = (field) => (data) => {
        const updated = { ...renderDetail }
        if (field === 'firstLvl' && renderDetail.secondLvl.value === data.value) { updated.secondLvl = { label: 'Нет', value: 'none' }}
        updated[field] = data;
        setRenderDetail(updated);
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('revenuePromotions', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportRevenue({}, 'revenuePromotions'));
        setRenderFilters(filters);
    }

    const getDetailOptions = (lvl) => {
        switch (lvl) {
            case 'firstLvl': {
                return firstLvlOptions.filter((option) => !option.noRenderFirst);
            }
            case 'secondLvl': {
                return firstLvlOptions.filter((option) => option.value !== renderDetail.firstLvl.value);
            }
            case 'thirdLvl': {
                const date_gte = moment(filters.created_at_gte);
                const date_lte = moment(filters.created_at_lte);
                const diff = date_lte.diff(date_gte, 'days');
                let value = null;
                if (diff === 0) value = 'day';
                if (diff === 6) value = 'week';
                if (diff > 6 && diff < 180) value = 'month';
                if (diff >= 180) value = 'year';
        
                return value ? dateOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : dateOptions;        
            }
            default: {
                return typeOptions;
            }
        }
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if (!filters.promotions || filters.promotions.length === 0) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }
    
    const onExport = () => {
        const { firstLvl, secondLvl, thirdLvl, fourthLvl } = renderDetail;
        const data = getGroupedData();
        const isRenderSecond = secondLvl && secondLvl.value !== 'none' && !isEmpty(data);
        const isRenderThrid = thirdLvl && thirdLvl.value !== 'none' && !isEmpty(data);
        const isRenderFourth = fourthLvl && fourthLvl.value !== 'none' && !isEmpty(data);

        const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
            const { field, sort } = _sort;
            const aField = a[field || 'name'];
            const bField = b[field || 'name'];
            if (sort === 'DESC') {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                    return 0;
                }
                return bField - aField;  
            } else {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                    return 0;
                }
                return aField - bField;                                                        
            }
        }).flatMap(([firstKey, firstData]) => {
            if (!isRenderSecond && !isRenderThrid && !isRenderFourth) {
                let entity = {};
                if (firstLvl.value === 'points') {
                    entity = { 'Филиал': firstKey };
                } else {
                    entity = { 'Акция': firstKey };
                }

                return {
                    ...entity,
                    'Заказы': firstData.count,
                    'Средний чек': firstData.receipt,
                    'Сумма': firstData.totalSum
                };
            }

            if (isRenderSecond && !isRenderThrid && !isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    let entity = {};
                    if (firstLvl.value === 'points') {
                        entity = { 'Филиал': firstKey, 'Акция': secondKey };
                    } else {
                        entity = { 'Акция': firstKey, 'Филиал': secondKey };
                    }

                    return {
                        ...entity,
                        'Заказы': secondData.count,
                        'Средний чек': secondData.receipt,
                        'Сумма': secondData.totalSum
                    };
                });
            }

            if (isRenderSecond && isRenderThrid && !isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([thridKey, thridData]) => {
                        const dateText = thirdLvl.value === 'day' ? 'Дата' : 'Период';
                        let entity = {};
                        if (firstLvl.value === 'points') {
                            entity = { 'Филиал': firstKey, 'Акция': secondKey, [dateText]: thridKey };
                        } else {
                            entity = { 'Акция': firstKey, 'Филиал': secondKey, [dateText]: thridKey };
                        }

                        return {
                            ...entity,
                            'Заказы': thridData.count,
                            'Средний чек': thridData.receipt,
                            'Сумма': thridData.totalSum
                        };
                    })
                });
            }

            if (isRenderSecond && !isRenderThrid && isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([fourthKey, fourthData]) => {
                        let dopText = fourthLvl.label || '-';
                        let entity = {};
                        if (firstLvl.value === 'points') {
                            entity = { 'Филиал': firstKey, 'Акция': secondKey, [dopText]: fourthKey };
                        } else {
                            entity = { 'Акция': firstKey, 'Филиал': secondKey, [dopText]: fourthKey };
                        }

                        return {
                            ...entity,
                            'Заказы': fourthData.count,
                            'Средний чек': fourthData.receipt,
                            'Сумма': fourthData.totalSum
                        };
                    })
                });
            }

            if (!isRenderSecond && isRenderThrid && !isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([thridKey, thridData]) => {
                    const dateText = thirdLvl.value === 'day' ? 'Дата' : 'Период';
                    let entity = {};

                    if (firstLvl.value === 'points') {
                        entity = { 'Филиал': firstKey, [dateText]: thridKey };
                    } else {
                        entity = { 'Акция': firstKey, [dateText]: thridKey };
                    }

                    return {
                        ...entity,
                        'Заказы': thridData.count,
                        'Средний чек': thridData.receipt,
                        'Сумма': thridData.totalSum
                    };
                });
            }

            if (!isRenderSecond && isRenderThrid && isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([thridKey, thridData]) => {
                    Object.entries(thridData.detailData).flatMap(([fourthKey, fourthData]) => {
                        const dateText = thirdLvl.value === 'day' ? 'Дата' : 'Период';
                        let dopText = fourthLvl.label || '-';
                        let entity = {};

                        if (firstLvl.value === 'points') {
                            entity = { 'Филиал': firstKey, [dateText]: thridKey, [dopText]: fourthKey };
                        } else {
                            entity = { 'Акция': firstKey, [dateText]: thridKey, [dopText]: fourthKey };
                        }

                        return {
                            ...entity,
                            'Заказы': fourthData.count,
                            'Средний чек': fourthData.receipt,
                            'Сумма': fourthData.totalSum
                        };
                    })
                });
            }

            if (!isRenderSecond && !isRenderThrid && isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([fourthKey, fourthData]) => {
                    let dopText = fourthLvl.label || '-';
                    let entity = {};
                    if (firstLvl.value === 'points') {
                        entity = { 'Филиал': firstKey, [dopText]: fourthKey };
                    } else {
                        entity = { 'Акция': firstKey, [dopText]: fourthKey };
                    }
                    return {
                        ...entity,
                        'Заказы': fourthData.count,
                        'Средний чек': fourthData.receipt,
                        'Сумма': fourthData.totalSum
                    };
                });
            }

            if (isRenderSecond && isRenderThrid && isRenderFourth) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([thridKey, thridData]) => {
                        return Object.entries(thridData.detailData).flatMap(([fourthKey, fourthData]) => {
                            const dateText = thirdLvl.value === 'day' ? 'Дата' : 'Период';
                            let dopText = fourthLvl.label || '-';
                            let entity = {};
                            if (firstLvl.value === 'points') {
                                entity = { 'Филиал': firstKey, 'Акция': secondKey, [dateText]: thridKey, [dopText]: fourthKey };
                            } else {
                                entity = { 'Акция': firstKey, 'Филиал': secondKey, [dateText]: thridKey, [dopText]: fourthKey };
                            }

                            return {
                                ...entity,
                                'Заказы': fourthData.count,
                                'Средний чек': fourthData.receipt,
                                'Сумма': fourthData.totalSum
                            };
                        })
                    })
                });
            }
        });

        const result = Object.values(data).reduce((acc, item) => {
            acc.totalSum += item.totalSum || 0;
            acc.count += item.count || 0;
            return acc;
        }, { totalSum: 0, count: 0 });
        
        const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;

        const keyName = firstLvl.value === 'points' ? 'Филиал' : 'Акция';
        
        exportData.push({
            [keyName]: 'ИТОГО',
            'Заказы': result.count,
            'Средний чек': receipt,
            'Сумма': result.totalSum
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Выручка по акциям');
        const detailText = [];
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        detailText.push(periodText);
        if (isRenderSecond) detailText.push(`Детализация 1 - ${secondLvl.label || '-'}`);
        if (isRenderThrid) detailText.push(`Детализация 2 - ${thirdLvl.label || '-'}`);
        if (isRenderFourth) detailText.push(`Детализация 3 - ${fourthLvl.label || '-'}`);
        const resultText = detailText.join(', ');
        writeFileXLSX(wb, `Отчет выручка по акциям ${resultText}.xlsx`);
    }

    const getPromotionsOptions = () => {
        if (!promotions || promotions.length === 0) return null;
        return promotions.map((promo) => ({ label: promo.name, value: promo.id })).sort((a, b) => {
            if(a.label.toLowerCase() < b.label.toLowerCase()) return -1;
            if(a.label.toLowerCase() > b.label.toLowerCase()) return 1;
            return 0;
        })
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Выручка по акциям
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect 
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={200} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div>
                        <label>Акции *</label>
                        <MultiSelect data={getPromotionsOptions()} width={200} placeholder='Акции' values={filters.promotions} setData={setFilters('promotions')} loading={loading} disabled={loading}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1 *</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('firstLvl')}
                            onChange={setDetail('firstLvl')}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.firstLvl}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Уровень 2</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('secondLvl')}
                            onChange={setDetail('secondLvl')}
                            placeholder="Уровень 2"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.secondLvl}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Уровень 3</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('thirdLvl')}
                            onChange={setDetail('thirdLvl')}
                            placeholder="Уровень 3"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.thirdLvl}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Уровень 4</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('fourthLvl')}
                            onChange={setDetail('fourthLvl')}
                            placeholder="Уровень 4"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.fourthLvl}                   
                        />
                    </div>
                </div>
            </div>
        );
    }


    const getGroupedData = () => {
        const { firstLvl, secondLvl, thirdLvl, fourthLvl } = renderDetail;
    
        const getFirstKeys = () => {
            const keys = new Set();

            if (firstLvl.value === 'points') {
                if (renderFilters.points && renderFilters.points.length > 0) {
                    renderFilters.points.forEach(point => {
                        const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                        if (dataPoint) return keys.add(renderAdress(dataPoint));
                    });
                } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                    renderFilters.regionalDirectors.forEach((dir) => {
                        if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                            if (point) {
                                let pointId = point.id ? point.id : point;
                                const dataPoint = points.find((point) => point.id === pointId);
                                return keys.add(renderAdress(dataPoint));
                            }
                            keys.add('Филиал не задан');
                        });
                    })
                } else {
                    result.forEach((order) => {
                        if (order && order.point) return keys.add(renderAdress(order.point));
                        keys.add('Филиал не задан');
                    });
                }
            } else {
                if (renderFilters.promotions && renderFilters.promotions.length > 0) {
                    renderFilters.promotions.forEach((promo) => {
                        if (promo) return keys.add(promo.label);
                    });
                }
            }
            
            return Array.from(keys);
        };

        const getSecondKeys = () => {
            if (secondLvl.value === 'none') return [];
            const keys = new Set();

            if (secondLvl.value === 'points') {
                if (renderFilters.points && renderFilters.points.length > 0) {
                    renderFilters.points.forEach(point => {
                        const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                        if (dataPoint) return keys.add(renderAdress(dataPoint));
                    });
                } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                    renderFilters.regionalDirectors.forEach((dir) => {
                        if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                            if (point) {
                                let pointId = point.id ? point.id : point;
                                const dataPoint = points.find((point) => point.id === pointId);
                                return keys.add(renderAdress(dataPoint));
                            }
                            keys.add('Филиал не задан');
                        });
                    })
                } else {
                    result.forEach((order) => {
                        if (order && order.point) return keys.add(renderAdress(order.point));
                        keys.add('Филиал не задан');
                    });
                }
            } else {
                if (renderFilters.promotions && renderFilters.promotions.length > 0) {
                    renderFilters.promotions.forEach((promo) => {
                        if (promo) return keys.add(promo.label);
                    });
                }
            }
            
            return Array.from(keys);
        }
    
        const getThirdKeys = () => {
            if (thirdLvl.value === 'none') return [];
            
            const startDate = moment(renderFilters.created_at_gte);
            const endDate = moment(renderFilters.created_at_lte);
            const dateKeys = [];

            switch (thirdLvl.value) {
                case 'day': {
                    let current = startDate.clone();
                    while (current <= endDate) {
                        dateKeys.push(current.format('DD.MM.YYYY'));
                        current.add(1, 'day');
                    }
                    break;
                }
                case 'week': {
                    let current = startDate.clone().startOf('isoWeek');
                    let end = endDate.clone().endOf('isoWeek');
                    
                    while (current <= end) {
                        let weekStart = current;
                        let weekEnd = current.clone().endOf('isoWeek');
        
                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                        
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }
                        
                        dateKeys.push(`${weekStart} - ${weekEnd}`);
                        current.add(1, 'week');
                    }
                    break;
                }
                case 'month': {
                    let current = startDate.clone().startOf('month');
                    let end = endDate.clone().endOf('month');
                    
                    while (current <= end) {
                        const monthStart = current.format('DD.MM.YYYY');
                        const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                        dateKeys.push(`${monthStart} - ${monthEnd}`);
                        current.add(1, 'month');
                    }
                    break;
                }
                default: break;
            }
            
            return dateKeys;
        };
    
        const getFourthKeys = () => {
            if (fourthLvl.value === 'none') return [];
            
            switch(fourthLvl.value ) {
                case 'delivery': {
                    return ['Доставка', 'Вынос'];
                }
                case 'payment': {
                    const paymentsData = [{ Name: 'cash', VisibleName: 'Наличные'}, { Name: 'terminal', VisibleName: 'Терминал'}, { Name: 'online', VisibleName: 'Юкасса'}, ...(payments || [])];
                    return paymentsData.map((pay) => pay.VisibleName);
                }
                case 'source': {
                    const arrSources = [
                        'Сайт', 
                        'Приложение', 
                        'КЦ', 
                        'Филиал', 
                        'CRM. Принадлежность роли не определена',
                    ]
                    platforms.forEach((source) => source.name && arrSources.push(source.name));
                    arrSources.push('Источник не определен')
                    return arrSources;
                }
                default: {
                    return [];
                }
            }
        };
    
        const createData = () => {
            const firstKeys = getFirstKeys();
            const secondKeys = getSecondKeys()
            const thridKeys = getThirdKeys();
            const fourthKeys = getFourthKeys();
            
            const data = {};
            
            
            firstKeys.forEach(firstKey => {
                const firstData = {
                    name: firstKey,
                    totalSum: 0,
                    plan: 0,
                    planPersent: 0,
                    count: 0,
                    receipt: 0,
                    detailData: {}
                };

                const getFourthData = (detailData) => {
                    fourthKeys.forEach((fourthKey) => {
                        const fourthKeyData = {
                            name: fourthKey,
                            totalSum: 0,
                            count: 0,
                            receipt: 0,
                            items: []
                        }
                        detailData[fourthKey] = fourthKeyData;
                    });
                    return detailData;
                }

                const getThridData = (detailData) => {
                    thridKeys.forEach((dateKey) => {
                        const dateData = {
                            name: dateKey,
                            totalSum: 0,
                            count: 0,
                            receipt: 0,
                            detailData: {}
                        };
                        
                        if (fourthLvl.value !== 'none') dateData.detailData = getFourthData(dateData.detailData);

                        detailData[dateKey] = dateData;
                    });
                    return detailData;
                }

                if (secondLvl.value !== 'none') {
                    secondKeys.forEach((secondKey) => {
                        const secondData = {
                            name: secondKey,
                            totalSum: 0,
                            count: 0,
                            receipt: 0,
                            detailData: {}
                        }
                        if (thirdLvl.value !== 'none') {
                            secondData.detailData = getThridData(secondData.detailData);
                        } else if (fourthLvl.value !== 'none') {
                            secondData.detailData =  getFourthData(secondData.detailData);
                        }
                        firstData.detailData[secondKey] = secondData;
                    });
                }
                
                if (secondLvl.value === 'none' && thirdLvl.value !== 'none') firstData.detailData = getThridData(firstData.detailData)
                    
                if (secondLvl.value === 'none' && thirdLvl.value === 'none' && fourthLvl.value !== 'none') firstData.detailData = getFourthData(firstData.detailData)
                
                data[firstKey] = firstData;
            });
            
            return data;
        };
        
        const getDateKeyOrders = (order) => {
            const time = parseInt(order.timeZone, 10) || 3;
            const baseOrderDate = order.visible_datetime || order.created_at;
            const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
            switch(thirdLvl.value) {
                case 'day': {
                    return orderDate.format('DD.MM.YYYY');
                }
                case 'week': {
                    const startDate = moment(renderFilters.created_at_gte);
                    const endDate = moment(renderFilters.created_at_lte);
                    let weekStart = orderDate.clone().startOf('isoWeek');
                    let weekEnd = orderDate.clone().endOf('isoWeek');
    
                    if (weekStart < startDate) {
                        weekStart = startDate.format('DD.MM.YYYY');
                    } else {
                        weekStart = weekStart.format('DD.MM.YYYY');
                    }
                
                    if (weekEnd > endDate) {
                        weekEnd = endDate.format('DD.MM.YYYY');
                    } else {
                        weekEnd = weekEnd.format('DD.MM.YYYY');
                    }
                    
                    return `${weekStart} - ${weekEnd}`;
                }
                case 'month': {
                    const monthStart = orderDate.startOf('month').format('DD.MM.YYYY');
                    const monthEnd = orderDate.endOf('month').format('DD.MM.YYYY');
                    return `${monthStart} - ${monthEnd}`;
                }
                default: {
                    return null;
                }
            }
        };
    
        const getFourthKeyOrder = (order) => {
            switch(fourthLvl.value) {
                case 'delivery': {
                    return order.deliveryMethod === 'delivery' ? 'Доставка' : 'Вынос';
                }
                case 'payment': {
                    const paymentsData = [...(payments || []), { Name: 'cash', VisibleName: 'Наличные'}, { Name: 'terminal', VisibleName: 'Терминал'}, { Name: 'online', VisibleName: 'Юкасса'}];
                    const pay = paymentsData.find((p) => p.Name === order.payment);
                    return (pay && pay.VisibleName) ? pay.VisibleName : 'Не определена';
                }
                case 'source': {
                    if (order.aggData && order.aggData.platform) {
                        const platform = platforms.find((source) => source.value === order.aggData.platform);
                        if (platform && platform.name) return platform.name;
                        return order.aggData.platform;
                    }

                    if (order.source && order.source !== 'crm') {
                        const platform = platforms.find((source) => source.value === order.source);
                        if (platform && platform.name) return platform.name;
                    }
    
                    if (order.source !== 'crm') {
                        if (order.isSite) return 'Сайт';
                        return 'Приложение';
                    }
                    
                    if (order.source === 'crm') {
                        if (order.authorRole) {
                            if ([roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC].includes(order.authorRole)) return 'КЦ';
                            if ([roleId.manager, roleId.cashier, roleId.regionalDirector].includes(order.authorRole)) return 'Филиал';
                            if (![roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC, roleId.manager, roleId.cashier, roleId.operationDirector].includes(order.authorRole)) return 'CRM. Принадлежность роли не определена';
                        }
                    }
                    
                    return 'Источник не определен';
                }
                default: {
                    return null;
                }
            }
        };

        const getKeyByLevel = (order, levelType) => {
            if (levelType === 'points') {
                return order.point ? renderAdress(order.point) : 'Филиал не задан';
            } else {
                if (order.promotion) {
                    const dataPromo = promotions.find((promo) => promo.id === order.promotion);
                    return dataPromo.name || 'Акция не найдена';
                }
                return 'Акция не найдена';
            }
        };

        const calculateReceiptForAllLevels = (detailData) => {
            Object.keys(detailData).forEach(key => {
                const item = detailData[key];
                
                if (item.count > 0) {
                    item.receipt = parseNumToFixed(item.totalSum / item.count);
                }
                
                if (item.detailData && Object.keys(item.detailData).length > 0) {
                    calculateReceiptForAllLevels(item.detailData);
                }
            });
            return detailData;
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((order) => {
                const totalPrice = parseFloat(order.totalPrice) || 0;

                const firstKey = getKeyByLevel(order, firstLvl.value);
                const secondKey = secondLvl.value !== 'none' ? getKeyByLevel(order, secondLvl.value) : null;
                const dateKey = thirdLvl.value !== 'none' ? getDateKeyOrders(order) : null;
                const fourthKey = fourthLvl.value !== 'none' ? getFourthKeyOrder(order) : null;
                
                if (updated[firstKey]) {
                    updated[firstKey].totalSum = parseNumToFixed((parseFloat(updated[firstKey].totalSum) || 0) + totalPrice);
                    updated[firstKey].count += 1;
                    
                    if (secondKey && updated[firstKey].detailData[secondKey]) {
                        const secondData = updated[firstKey].detailData[secondKey];
                        secondData.totalSum = parseNumToFixed((parseFloat(secondData.totalSum) || 0) + totalPrice);
                        secondData.count += 1;
                        
                        if (dateKey && secondData.detailData[dateKey]) {
                            const thirdData = secondData.detailData[dateKey];
                            thirdData.totalSum = parseNumToFixed((parseFloat(thirdData.totalSum) || 0) + totalPrice);
                            thirdData.count += 1;
                            
                            if (fourthKey && thirdData.detailData[fourthKey]) {
                                const fourthData = thirdData.detailData[fourthKey];
                                fourthData.totalSum = parseNumToFixed((parseFloat(fourthData.totalSum) || 0) + totalPrice);
                                fourthData.count += 1;
                            }
                        }
                        else if (fourthKey && secondData.detailData[fourthKey]) {
                            const fourthData = secondData.detailData[fourthKey];
                            fourthData.totalSum = parseNumToFixed((parseFloat(fourthData.totalSum) || 0) + totalPrice);
                            fourthData.count += 1;
                        }
                    }
                    else if (dateKey && updated[firstKey].detailData[dateKey]) {
                        const thirdData = updated[firstKey].detailData[dateKey];
                        thirdData.totalSum = parseNumToFixed((parseFloat(thirdData.totalSum) || 0) + totalPrice);
                        thirdData.count += 1;
                        
                        if (fourthKey && thirdData.detailData[fourthKey]) {
                            const fourthData = thirdData.detailData[fourthKey];
                            fourthData.totalSum = parseNumToFixed((parseFloat(fourthData.totalSum) || 0) + totalPrice);
                            fourthData.count += 1;
                        }
                    }
                    else if (fourthKey && updated[firstKey].detailData[fourthKey]) {
                        const fourthData = updated[firstKey].detailData[fourthKey];
                        fourthData.totalSum = parseNumToFixed((parseFloat(fourthData.totalSum) || 0) + totalPrice);
                        fourthData.count += 1;
                    }
                }
            });
            
            return calculateReceiptForAllLevels(updated);
        };
    
        const data = createData();
        const filledData = fillNullData(data);

        return filledData;
    };

    const renderTable = () => {
        const { field, sort } = _sort;
        const { secondLvl, thirdLvl, fourthLvl } = renderDetail;
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <SortButton 
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наименование' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Заказы' 
                                onClick={() => handleClickSort('count')} 
                                up={field === 'count' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'receipt' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Ср. чек' 
                                onClick={() => handleClickSort('receipt')} 
                                up={field === 'receipt' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                            <SortButton 
                                className={field === 'totalSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Сумма' 
                                onClick={() => handleClickSort('totalSum')} 
                                up={field === 'totalSum' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {Object.entries(data)
                        .sort(([aKey, a], [bKey, b]) => {
                            const { field, sort } = _sort;
                            const aField = a[field || 'name'];
                            const bField = b[field || 'name'];
                            if (sort === 'DESC') {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return bField - aField;  
                            } else {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return aField - bField;                                                        
                            }
                        })
                        .map(([key, item]) => <ItemRow item={item} secondLvl={secondLvl} thirdLvl={thirdLvl} fourthLvl={fourthLvl}/>)}
                        <ResultRow items={data}/>
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="revenuePromotions" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}